<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure"> </p>
<p class="body_Dedication"><span class="CharOverride-6"> </span></p>
<p class="body_Dedication"><span class="CharOverride-6">To the love of my life, Monica, for</span><span class="CharOverride-6"> ins</span><span class="noBreak CharOverride-6">piring</span><span class="noBreak CharOverride-6"> </span><span class="noBreak CharOverride-6">me,</span></p>
<p class="body_Dedication"><span class="CharOverride-6">motivating me, and constant</span><span class="noBreak CharOverride-6">ly</span><span class="noBreak CharOverride-6"> </span><span class="noBreak CharOverride-6">pushing</span></p>
<p class="body_Dedication"><span class="CharOverride-6">me to be</span><span class="CharOverride-6"> a better man, more creativ</span><span class="noBreak CharOverride-6">e, and</span><span class="noBreak CharOverride-6"> </span><span class="noBreak CharOverride-6">for</span></p>
<p class="body_Dedication"><span class="CharOverride-6">the idea that</span><span class="CharOverride-6"> started this whole wil</span><span class="noBreak CharOverride-6">d</span><span class="noBreak CharOverride-6"> </span><span class="noBreak CharOverride-6">journey!</span></p>
<p class="body_Dedication"><span class="CharOverride-6">Thank you for roughing it</span><span class="CharOverride-6"> o</span><span class="noBreak CharOverride-6">ut with</span><span class="noBreak CharOverride-6"> </span><span class="noBreak CharOverride-6">me</span></p>
<p class="body_Dedication"><span class="CharOverride-6">while this whole thing w</span><span class="noBreak CharOverride-6">orked</span><span class="noBreak CharOverride-6"> </span><span class="noBreak CharOverride-6">out,</span></p>
<p class="body_Dedication"><span class="CharOverride-6">Love</span><span class="noBreak CharOverride-6"> </span><span class="CharOverride-6">you</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MakingVeganMeat-3.vue?01d907f1